import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import calculator from "./PriceCalculator";

/* eslint-disable import/no-webpack-loader-syntax */

import CartItemStyles from "./CartItem.css";
import MinusIcon from "-!svg-react-loader!../icons/minus.svg";
import PlusIcon from "-!svg-react-loader!../icons/plus.svg";
import TrashIcon from "-!svg-react-loader!../icons/trash-2.svg";
import EditIcon from "-!svg-react-loader!../icons/pen-2.svg";
import CartItemResIcon from "-!svg-react-loader!../icons/cart-item-res.svg";
import DetailWindowSize from "./cart-item/window-size";
import utilities from "./Utilities";
let Utilities = new utilities();
let Calculator = new calculator();

export default class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Calculator: new calculator(),
      randomId: "0",
      isAdmin: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize);

    if (!Utilities.isENU(this.props.item.localId)) {
      console.log(this.props.item);

      let cartItem = this.props.item;
      let newState = {};

      newState.localId = cartItem.localId;

      console.log(this.state.previewMatteColor, "<<<<<<<<<<<<<<<<<<<<<");

      newState.artworkHeight = cartItem.artworkHeight;
      this.state.Calculator.setArtworkHeight(newState.artworkHeight);
      newState.artworkWidth = cartItem.artworkWidth;
      this.state.Calculator.setArtworkWidth(newState.artworkWidth);
      newState.frameStyle = cartItem.frameStyle;
      newState.frameStyleText = cartItem.frameStyle
        .replace("<strong>", "")
        .replace("</strong>", "");
      this.state.Calculator.setFrameStyle(
        newState.frameStyle,
        cartItem.frameId
      );
      newState.matteWidth = cartItem.matteWidth;
      this.state.Calculator.setMatteWidth(newState.matteWidth);
      newState.glazing = cartItem.glazing;
      this.state.Calculator.setGlazing(newState.glazing);
      newState.backing = cartItem.backing;
      this.state.Calculator.setBacking(newState.backing);
      newState.matteColor = cartItem.matteColor;
      newState.matteId = cartItem.matteId;
      this.state.Calculator.setMatteColor(newState.matteColor);
      // Calculate with quantity muliplied
      newState.quantity = cartItem.quantity;
      this.state.Calculator.setQuantity(newState.quantity);
      newState.hanging = cartItem.hanging;
      this.state.Calculator.setHanging(newState.hanging);
      newState.hangingDisplayName = cartItem.hangingDisplayName;
      newState.artworkWidthNominal = cartItem.artworkWidthNominal;
      newState.artworkHeightNominal = cartItem.artworkHeightNominal;
      newState.frameWidthNominal = cartItem.frameWidthNominal;
      newState.frameHeightNominal = cartItem.frameHeightNominal;
      newState.externalWidthNominal = cartItem.externalWidthNominal;
      newState.externalHeightNominal = cartItem.externalHeightNominal;
      newState.windowWidthNominal = cartItem.windowWidthNominal;
      newState.windowHeightNominal = cartItem.windowHeightNominal;
      newState.frameImgUrl = Calculator.getFrameImgUrl(cartItem.frameStyle);

      (newState.matteBoardHeight = cartItem.matteBoardHeight),
        (newState.matteBoardWidth = cartItem.matteBoardWidth),
        (newState.internalHeight = cartItem.internalHeight),
        (newState.internalWidth = cartItem.internalWidth),
        (newState.rabbetEdgeHeight = cartItem.rabbetEdgeHeight),
        (newState.rabbetEdgeWidth = cartItem.rabbetEdgeWidth),
        this.setState(newState, function() {
          this.state.Calculator.calculate();
          this.updateCartItem();
          this.renderFrame();
        });
    }

    let user = JSON.parse(localStorage.getItem("user"));

    if (!Utilities.isENU(user) && user.type < 3) {
      this.setState({
        isAdmin: true,
      });
    }
  }

  onResize = () => {
    this.renderFrame();

    // setTimeout(function() {
    //     this.renderFrame()
    // }.bind(this), 1000);
  };

  renderFrame = () => {
    let frame = document.getElementById(this.state.localId);

    if (frame !== null) {
      console.log(
        "RENDERING!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!"
      );

      let frameWidth = frame.offsetWidth;
      let frameWidthRatio = frameWidth / this.state.externalWidthNominal;

      let frameHeight = this.state.externalHeightNominal * frameWidthRatio;

      let frameBorderWidth =
        this.state.Calculator.calculatedValues.frameWidth * frameWidthRatio;
      let previewMatteWidth =
        this.state.Calculator.userFields.matteWidth * frameWidthRatio;

      let cropperHeight = Math.round(
        frameHeight - (frameBorderWidth + previewMatteWidth) * 2
      );
      let cropperWidth = Math.round(
        frameWidth - (frameBorderWidth + previewMatteWidth) * 2
      );
      cropperHeight++;
      cropperWidth++;

      let color = this.state.Calculator.getFrameStyleColor();
      let matteColor = this.state.Calculator.getMatteColorRGB();

      let frameBorderReal = this.state.Calculator.calculatedValues.frameWidth;
      console.log("FRAME BORDER REAL", frameBorderReal);

      // if (!Utilities.isENU(color)) {

      console.log(
        cropperWidth,
        cropperHeight,
        color,
        frameBorderReal,
        matteColor,
        frameBorderWidth,
        previewMatteWidth,
        "=================!!!!!!!!!========================="
      );

      this.setState({
        cropperWidth: cropperWidth,
        cropperHeight: cropperHeight,
        // frameHeight: frameHeight,
        // frameWidth: frameWidth,
        frameColor: color || "555",
        frameBorderReal: frameBorderReal,
        previewMatteColor: matteColor,
        frameBorderWidth: frameBorderWidth,
        previewMatteWidth: previewMatteWidth,
      });

      // }
    }
  };

  updateQuanitity = (value) => {
    console.log("updateing quantity " + value, typeof value);

    if (value === "" || isNaN(value)) {
      value = 1;
    }

    this.setState({ quantity: value });

    // if (!isNaN(parseInt(value))) {
    //     value = 1;
    // }
    this.props.updateQuanitity(this.state.localId, value);
  };

  remove = () => {
    this.props.remove(this.state.localId);
  };

  updateCartItem = () => {
    this.setState(
      {
        artworkWidth: this.state.Calculator.userFields.artworkWidth,
        artworkHeight: this.state.Calculator.userFields.artworkHeight,
        // frameWidth: this.state.Calculator.calculatedValues.externalWidthNominal,
        // frameHeight: this.state.Calculator.calculatedValues.externalHeightNominal,
        frameStyle: this.state.Calculator.userFields.frameType,
        price: this.state.Calculator.calculatedValues.totalCost,
      },
      function() {
        this.props.onPriceUpdated(
          this.state.localId,
          this.state.Calculator.calculatedValues.totalCost
        );
        console.log(this.state, "====");
      }.bind(this)
    );
  };

  componentWillReceiveProps(nextProps) {
    let item = { ...this.state.item };

    if (nextProps.item !== undefined) {
      this.state.Calculator.setQuantity(nextProps.item.quantity);

      this.setState(
        {
          item: nextProps.item,
        },
        function() {
          this.state.Calculator.calculate();
          this.updateCartItem();
        }.bind(this)
      );
    }
  }

  render() {
    console.log(Utilities.isENU(this.state.frameImgUrl));
    // let item = this.props.item || {
    let item = this.state;

    if (!Utilities.isENU(item.matteColor)) {
      item.matteColor = Utilities.capitalize(item.matteColor);
    }

    return (
      <div className='cart-item' data-section={this.props.section}>
        <div className='preview'>
          <div
            class='cart-frame frame'
            id={this.state.localId}
            style={{
              height: this.state.frameHeight,
              borderColor: Utilities.isENU(this.state.frameColor)
                ? "#fff"
                : "#" + this.state.frameColor,
              borderWidth: this.state.frameBorderWidth,
              backgroundColor: Utilities.isENU(this.state.previewMatteColor)
                ? "#fff"
                : "#" + this.state.previewMatteColor,
              borderImageWidth: this.state.frameBorderWidth + "px",
              borderImageSource: Utilities.isENU(this.state.frameImgUrl)
                ? "unset"
                : "url('" + this.state.frameImgUrl + "')",
              borderImageRepeat: Utilities.isENU(this.state.frameImgUrl)
                ? "unset"
                : "stretch",
              borderImageSlice:
                this.state.frameBorderReal === 1
                  ? '8%'
                  : this.state.frameBorderReal === 2
                  ? '8%'
                  : this.state.frameBorderReal === 3
                  ? '8%'
                  : '8%',
            }}
          >
            <div
              className='matte'
              id='main-matte'
              style={{
                // borderColor: ( (Utilities.isENU(this.state.previewMatteColor)) ? "#fff" : "#" + this.state.previewMatteColor ),
                borderWidth: this.state.previewMatteWidth,
              }}
            >
              <div
                className='cropper-dummy'
                style={{
                  width: this.state.cropperWidth + "px",
                  height: this.state.cropperHeight + "px",
                }}
              >
                <CartItemResIcon />
              </div>
            </div>
          </div>
        </div>
        {this.state.isAdmin || this.props.isAdmin ? (
          <div className='details'>
            <div className='detail'>
              <div className='field'>Frame Id</div>
              <div className='value'>
                {item.item !== undefined ? item.item.frameId : ""}
              </div>
            </div>
            <div className='detail'>
              <div className='field'>Frame Style</div>
              <div className='value'>{item.frameStyleText}</div>
            </div>
            <div className='detail'>
              <div className='field'>Internal Size</div>
              <div className='value'>
                {item.internalHeight +
                  "cm (h) x " +
                  item.internalWidth +
                  "cm (w)"}
              </div>
            </div>

            <hr />

            <div className='detail'>
              <div className='field'>Mat Id</div>
              <div className='value'>
                {item.matteWidth === 0 || item.matteWidth === null
                  ? "None"
                  : item.matteId}
              </div>
            </div>
            <div className='detail'>
              <div className='field'>Mat Colour</div>
              <div className='value'>
                {item.matteWidth === 0 || item.matteWidth === null
                  ? "None"
                  : item.matteColor}
              </div>
            </div>
            <div className='detail'>
              <div className='field'>Mat Border Size (visible)</div>
              <div className='value'>{item.matteWidth || 0}cm</div>
            </div>
            <div className='detail'>
              <div className='field'>Mat Board Size</div>
              <div className='value'>
                {item.matteBoardHeight +
                  "cm (h) x " +
                  item.matteBoardWidth +
                  "cm (w)"}
              </div>
            </div>

            {this.state.matteWidth > 0 ?
                <DetailWindowSize
                    windowHeightNominal={this.state.windowHeightNominal}
                    windowWidthNominal={this.state.windowWidthNominal}
                />
                : null
            }

            <hr />

            <div className='detail'>
              <div className='field'>Glazing</div>
              <div className='value'>{item.glazing}</div>
            </div>
            <div className='detail'>
              <div className='field'>Backing</div>
              <div className='value'>PVC</div>
            </div>
            <div className='detail'>
              <div className='field'>Components</div>
              <div className='value'>Black metal flexi tabs</div>
            </div>
            <div className='detail'>
              <div className='field'>Hanging Type</div>
              <div className='value'>Wire or strap hanger</div>
            </div>
            <div className='detail'>
              <div className='field'>Stand</div>
              <div className='value'>
                {item.hanging === "Not Selected" ? "None" : "Yes"}
              </div>
            </div>
            <div className='detail'>
              <div className='field'>External Size</div>
              <div className='value'>
                {item.externalHeightNominal +
                  "cm (h) x " +
                  item.externalWidthNominal +
                  "cm (w)"}
              </div>
            </div>
            {this.props.section === "order" && (
              <div className='detail'>
                <div className='field'>Quantity</div>
                <div className='value'>{item.quantity}</div>
              </div>
            )}
            <div className='detail'>
              <div className='field'>Artwork Size Ref</div>
              <div className='value'>
                {item.artworkHeightNominal +
                  "cm (h) x " +
                  item.artworkWidthNominal +
                  "cm (w)"}
              </div>
            </div>
            {/*<div className="detail">
                            <div className="field">Artwork Size</div>
                            <div className="value">{item.artworkHeightNominal + "cm (h) x " + item.artworkWidthNominal + "cm (w)"}</div>
                        </div>*/}
            {/*<div className="detail">
                            <div className="field">Frame Size</div>
                            <div className="value">{item.frameHeightNominal + "cm (h) x " + item.frameWidthNominal + "cm (w)"}</div>
                        </div>*/}
            {/*(this.state.isAdmin || this.props.isAdmin) &&
                            <div className="detail">
                                <div className="field">Rabbet Edge</div>
                                <div className="value">{item.rabbetEdgeHeight + "cm (h) x " + item.rabbetEdgeWidth + "cm (w)"}</div>
                            </div>
                        */}
          </div>
        ) : (
          <div className='details'>
            <h3>Details</h3>
            <div className='detail'>
              <div className='field'>Artwork Size</div>
              <div className='value'>
                {item.artworkHeightNominal +
                  "cm (h) x " +
                  item.artworkWidthNominal +
                  "cm (w)"}
              </div>
            </div>
            <div className='detail'>
              <div className='field'>External Size</div>
              <div className='value'>
                {item.externalHeightNominal +
                  "cm (h) x " +
                  item.externalWidthNominal +
                  "cm (w)"}
              </div>
            </div>
            {this.state.matteWidth > 0 ?
                <DetailWindowSize
                    windowHeightNominal={this.state.windowHeightNominal}
                    windowWidthNominal={this.state.windowWidthNominal}
                />
                : null
            }
            {item.hanging && item.hanging !== "Not Selected" && (
              <div className='detail'>
                <div className='field'>Hanging Type</div>
                <div className='value'>{item.hanging}</div>
              </div>
            )}
            <div className='detail'>
              <div className='field'>Frame Style</div>
              <div className='value'>{item.frameStyleText}</div>
            </div>
            <div className='detail'>
              <div className='field'>Mat Colour</div>
              <div className='value'>{item.matteColor}</div>
            </div>
            <div className='detail'>
              <div className='field'>Mat Border Size</div>
              <div className='value'>{item.matteWidth}cm</div>
            </div>
            <div className='detail'>
              <div className='field'>Glazing</div>
              <div className='value'>{item.glazing}</div>
            </div>
            {this.props.section === "order" && (
              <div className='detail'>
                <div className='field'>Quantity</div>
                <div className='value'>{item.quantity}</div>
              </div>
            )}
          </div>
        )}
        <div className='price'>
          {this.props.section !== "order" && (
            <div className='quantity'>
              <h3>Quantity</h3>
              <div className='plus-minus'>
                <div
                  className='controller'
                  onClick={(e) => {
                    if (item.quantity > 1) {
                      this.updateQuanitity(item.quantity - 1);
                    }
                  }}
                >
                  {" "}
                  <MinusIcon />{" "}
                </div>
                <div className='value'>
                  {" "}
                  <span> {item.quantity} </span>{" "}
                </div>
                <div
                  className='controller'
                  onClick={(e) => {
                    if (item.quantity < 100) {
                      this.updateQuanitity(item.quantity + 1);
                    }
                  }}
                >
                  {" "}
                  <PlusIcon />{" "}
                </div>
              </div>
            </div>
          )}
          <div className='price'>
            <h3>Price</h3>
            <p>
              {window.currency}
              {this.props.price
                ? parseInt(this.props.price)
                : item.price
                ? parseInt(item.price)
                : ""}
            </p>
          </div>
          {this.props.section !== "order" && (
            <div className='options'>
              <Link to={"/build/frame/" + this.state.localId}>
                <EditIcon />
                <span>Edit</span>
              </Link>
              <button
                onClick={(e) => {
                  if (
                    window.confirm(
                      "Are you sure you want to delete this item from the cart?"
                    )
                  )
                    this.remove(e);
                }}
              >
                <TrashIcon />
                <span>Delete</span>
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CartItem.js